import { useMsal, useAccount } from "@azure/msal-react";
import { ACCESS_TOKEN_KEY } from "./useAccessToken";
import { clearLoginRetryState } from "../auth/loginHelpers";

export function useAuth() {
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  const logout = async () => {
    try {
      sessionStorage.removeItem(ACCESS_TOKEN_KEY);
      clearLoginRetryState();
      await instance.logoutRedirect({
        postLogoutRedirectUri: `${window.location.origin}/login`,
      });
    } catch (error) {
      console.error("MSAL: logout failed", error);
    }
  };

  const getAccessToken = async (scopes?: string[]): Promise<string | null> => {
    if (!account) {
      return null;
    }

    try {
      const response = await instance.acquireTokenSilent({
        scopes: scopes || ["User.Read", "openid", "profile", "email"],
        account: account,
      });
      return response.accessToken;
    } catch (error) {
      console.error("Failed to acquire access token:", error);
      return null;
    }
  };

  return {
    logout,
    isAuthenticated: !!account,
    account,
    getAccessToken,
  };
}
